import React, {useState} from 'react'
import { IOrderItem } from '../../../../../modules/API/Drivers/models/kavData'
import styled from 'styled-components';
import { TitleItem, TitleRow } from './ColumClientElem';
import AcceptIcon from '../../../../../generic/icons/IconLib/CheckIcon';
import EditIcon from '../../../../../generic/icons/IconLib/PencilIcon';
import InvoiceIcon from '../../../../../generic/icons/IconLib/InvoiceIcon';
import PackageIcon from '../../../../../generic/icons/IconLib/PackageBoxIcon';
import PalletIcon from '../../../../../generic/icons/IconLib/PalletIcon';
import ScalesIcon from '../../../../../generic/icons/IconLib/ScaleIcon';
import ColumnPalletItem from './ColumnPalletItem';
import StatusReturningBadge from '../../drivers/Components/StatusReturningBadge';

interface IProps extends IOrderItem  {
    item: IOrderItem;
    ordersAllowToShow: number[];
    isRehesh?: boolean;
    handleSelectToDrag: (elementID: number, kavID: number, CustomerID: number, OrderID: number, isOrder?: boolean ) => void;
    handleClickSelectOrder: (item: IOrderItem, area: number, CustomerID: number) => void;
    area: number;
    CustomerID: number

}

const ColumnOrderElement = ({
    item, OrderID, ordersAllowToShow, PalletsList, Weight, isRehesh,
    Pallets, Packs, handleSelectToDrag, area, CustomerID, Selected,
    handleClickSelectOrder, DistributNote, IsProblem, DriverStatus
}: IProps) => {
    const [isOpen, setIsOpen] = useState(false)
    const calcWeightPallet = () => {
        let weightCalc, palletCalc, packagesCalc
        if(PalletsList.length === 0) {
            weightCalc = Math.round(Weight);
            palletCalc = +Pallets.toFixed(2);
            packagesCalc = Packs
        } else {
            const reduced = PalletsList.reduce((acc: Record<string, number>, cur) => {
                acc.weight = (acc.weight ? acc.weight : 0 ) + (cur.Gross || 0); 
                acc.pallets = (acc.pallets ? acc.pallets : 0 ) + (cur.PallQty || 0); 
                acc.packs = (acc.packs ? acc.packs : 0 ) + (cur.Qty || 0); 
                return acc    
            }, {})
            weightCalc = reduced.weight
            palletCalc = reduced.pallets
            packagesCalc = reduced.packs
        }
        return {weightCalc: Math.round(weightCalc), palletCalc, packagesCalc}
    } 

    const {weightCalc, palletCalc, packagesCalc} = calcWeightPallet()

    const handleOpenPallets = (e: React.MouseEvent) => {
        e.stopPropagation();
        setIsOpen(!isOpen);
    }
    const handleSelect = ((e: React.MouseEvent) => {
        e.stopPropagation();
        handleSelectToDrag(OrderID, area, CustomerID, OrderID, true)

    })
    const handleSelectOrderForRemark = (e: React.MouseEvent) => {
        e.stopPropagation()
        handleClickSelectOrder(item, area, CustomerID)
    }
  return (
    <MainWrapper 
        onClick={handleOpenPallets}
        $isProblem={IsProblem}
        // Selected={Selected}
    >   
        {
            !isRehesh &&
            <CheckBox
                onClick={handleSelect}
                $isProblem={IsProblem}
            >
                {
                    Selected &&
                    <AcceptIcon />

                }
            </CheckBox>
        }
        <TitleRow>
            <TitleItem>
                <InvoiceIcon />
                {OrderID}
                <SelectWorkerButton 
                    $isMarked={!!DistributNote.trim()}
                    onClick={handleSelectOrderForRemark}
                >
                    <EditIcon />
                </SelectWorkerButton>
            </TitleItem>
        </TitleRow>
        <TitleRow>
            {
                IsProblem &&
                <StatusReturningBadge status={DriverStatus} />
            }
            {
                !IsProblem && (
                    <TitleItem>
                        <PalletIcon />
                        {palletCalc}
                    </TitleItem>
                )
            }
           
            <TitleItem>
                <ScalesIcon />
                {weightCalc}
            </TitleItem>
            <TitleItem>
                <PackageIcon />
                {packagesCalc}
            </TitleItem>
            
        </TitleRow>
            {
                isOpen && PalletsList.length > 0 &&
                    <BodyWrapper>
                        {
                            PalletsList.map((item, index) =>
                                <ColumnPalletItem 
                                    key={item.Pallet_Num}
                                    handleSelectToDrag={handleSelectToDrag}
                                    {...item}
                                    area={area}
                                    OrderID={OrderID}
                                    CustomerID={CustomerID}
                                />
                            )
                        }
                    </BodyWrapper>
            }
        
    </MainWrapper>
  )
}

const MainWrapper = styled.div<{$isProblem?: boolean}>`
    position: relative;
    width: 100%;
    background: #e9f3f2;
    border-right: ${props => props.$isProblem ? '6px solid tomato' : 'none'};
    border-radius: 10px;
    display: flex;
    flex-flow: column;
    padding: 0.5em 0.2em;
    gap: 0.3em;
`
const CheckBox = styled.div<{$isProblem?: boolean}>`
    position: absolute;
    left: 0.5em;
    padding: 0.3em;
    border-radius: 50%;
    height: 2em;
    width: 2em;
    border: 2px solid ${props => props.$isProblem ? 'tomato' : '#80e081'};
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${props => props.$isProblem ? 'tomato' : '#80e081'};

`
const BodyWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-flow: column;
    gap: 0.5em;
    /* border-top: 1px solid gray; */
    border-radius: 20px;
    background: #fff;
    padding: 0.5em 0.2em;

`
export const SelectWorkerButton = styled.div<{$isMarked?: boolean}>`
    border-radius: 5px;
    color: #ffff;
    padding: 0.1em 0.5em;
    display: flex;
    align-items: center;
    background: ${props => props.$isMarked ? 'tomato' : "#297f76"} ;
    transform: translateY(-2px);
    font-size: 0.7em;
    cursor: pointer;
`
export default ColumnOrderElement